import i18n from '@/libs/i18n'
// *===============================================---*
// *--------- UNITS ---------------------------*
// *===============================================---*
export default [
  {
    path: '/units/list',
    name: 'pages-units-list',
    component: () => import('@/views/pages/units/unitsList.vue'),
    meta: {
      action: 'read',
      resource: 'unit',
      required: true,
      breadcrumb: [
        {
          text: i18n.t('general.list'),
        },
      ],
      pageTitle: i18n.t('unit.units'),
    },
  },
  {
    path: '/unit/add',
    name: 'pages-units-add',
    component: () => import('@/views/pages/units/unitAdd.vue'),
    meta: {
      action: 'create',
      resource: 'unit',
      breadcrumb: [
        {
          text: i18n.t('unit.createUnit'),
        },
      ],
      pageTitle: i18n.t('unit.createUnit'),
    },
  },
  {
    path: '/unit/edit/:id',
    name: 'pages-units-edit',
    component: () => import('@/views/pages/units/unitEdit.vue'),
    meta: {
      action: 'update',
      resource: 'unit',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
        },
      ],
      pageTitle: i18n.t('unit.unitEdit'),
    },

  },
]
